<template>
  <div class="home">
    <div class="box1">
      <video
        class="banner-video"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        x5-playsinline
        preload="auto"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
      >
        <source src="http://qiniu.ijuying.com/wushui2.mp4" type="video/mp4" />
      </video>
      <div class="anchor-panel">
        <div
          class="anchor-point"
          :class="{ 'align-left': point.align === 'left' }"
          v-for="point in anchorPoints"
          :key="point.id"
          :style="anchorStyle(point)"
          @mouseenter="hoveredAnchor = point.id"
          @mouseleave="hoveredAnchor = null"
          @click="handleAnchorClick(point)"
        >
          <div class="anchor-dot">
            <span class="dot-wave"></span>
            <span class="dot-wave delay"></span>
            <span class="dot-core"></span>
          </div>
          <div
            class="anchor-card"
            :class="{ 'is-visible': hoveredAnchor === point.id }"
            @click.stop="handleAnchorClick(point)"
          >
            <i :class="['anchor-icon', point.icon]"></i>
            <div class="anchor-text">
              <h4>{{ point.title }}</h4>
              <p>{{ point.desc }}</p>
            </div>
            <i class="el-icon-arrow-right anchor-arrow"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="box2" ref="box2Section">
      <div class="content">
        <div class="box2_left">
          <div class="guanyu" :class="{ 'animate-guanyu': guanyuVisible }">
            <div class="en_title">About Yuedong New Energy</div>
            <div class="ch_title">关于跃动新能源</div>
            <p>
              跃动新能源科技(浙江)有限公司系浙江省重点项目，具备液态及固态锂离子电池，储能及动力系统完整的研发生产体系。核心业务团队来自全球头部锂电企业，具备超过15年的电池研发、生产及交付经验。
              自主研发的液态及固态锂离子电池，在安全性能、快充性能与循环寿命等方面具备核心竞争优势。电池系统涵盖源网侧储能、用户侧储能、家用及移动储能、重卡动力、智能机械等终端应用场景。可根据用户需求快速响应提供个性化设计及电池生命周期管理方案。
            </p>
          </div>
          <div
            class="yewu"
            ref="modelSection"
            :class="{ 'is-visible': modelVisible }"
          >
            <div
              class="title-group"
              :class="{ 'animate-guanyu': modelVisible }"
            >
              <div class="en_title">Main Business</div>
              <div class="ch_title">主营业务</div>
            </div>
            <div class="xinghao" ref="modelTrigger">
              <h1>电芯型号</h1>
              <div class="rongqi">
                <div
                  class="xinghao_box"
                  v-for="(_, idx) in 3"
                  :key="`type-a-${idx}`"
                  :style="cardAnimationStyle(idx)"
                >
                  <img src="../assets/xinghao1.png" alt="" />
                  <span>LFP280Ah</span>
                </div>
              </div>
            </div>
            <div class="xinghao">
              <h1>电芯型号</h1>
              <div class="rongqi">
                <div
                  class="xinghao_box"
                  v-for="(_, idx) in 4"
                  :key="`type-b-${idx}`"
                  :style="cardAnimationStyle(idx, 3)"
                >
                  <img src="../assets/xinghao1.png" alt="" />
                  <span>LFP280Ah</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box2_right">
          <div
            :class="{
              'animate__animated animate__slideInRight': box2RightVisible,
            }"
          >
            <div class="en_title">Construction Plan</div>
            <div class="ch_title">建设规划</div>
            <h1>首个生产基地坐落于东阳新能源产业园</h1>
          </div>
          <div class="guihua">
            <div
              class="guihua_box"
              :class="{
                'animate__animated animate__backInRight': guihuaVisible,
              }"
              v-for="(item, index) in guihuaData"
              :key="index"
              :style="{
                animationDelay: guihuaVisible ? `${0.5 + index * 0.3}s` : '0s',
              }"
              ref="guihuaBoxes"
              @animationend="handleGuihuaAnimationEnd($event, index)"
            >
              <img :src="item.img" alt="" />
              <span>{{ item.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box3" ref="box3Section">
      <ul>
        <li :class="{ active: currentModelTab === 0 }" @click="setModelTab(0)">
          业务布局
        </li>
        <li :class="{ active: currentModelTab === 1 }" @click="setModelTab(1)">
          产品案例
        </li>
      </ul>
      <div class="model">
        <div
          class="model_item"
          :class="{
            'animate__animated animate__fadeInUp': box3Visible,
          }"
          :style="{
            animationDelay: box3Visible ? '0.3s' : '0s',
          }"
        >
          <div class="model_item-inner">
            <div class="model_item-face model_item-front bg0">
              <img src="../assets/buju_icon0.png" alt="" />
              <span></span>
              <h1>光伏发电</h1>
              <h2>一站式建站服务，涵盖分布式工商业光伏、地面光伏</h2>
            </div>
            <div class="model_item-face model_item-back">
              <h3>光伏发电</h3>
              <p>提供全流程光伏解决方案，覆盖设计、建设、运维。</p>
              <span class="back-cta">了解更多 →</span>
            </div>
          </div>
        </div>
        <div
          class="model_item"
          :class="{
            'animate__animated animate__fadeInUp': box3Visible,
          }"
          :style="{
            animationDelay: box3Visible ? '0.6s' : '0s',
          }"
        >
          <div class="model_item-inner">
            <div class="model_item-face model_item-front bg1">
              <img src="../assets/buju_icon1.png" alt="" />
              <span></span>
              <h1>智慧运维</h1>
              <h2>提前预警、快速响应、保障电站安全、稳定发电</h2>
            </div>
            <div class="model_item-face model_item-back">
              <h3>智慧运维</h3>
              <p>AI 赋能的监控预警与快速响应体系。</p>
              <span class="back-cta">查看详情 →</span>
            </div>
          </div>
        </div>
        <div
          class="model_item"
          :class="{
            'animate__animated animate__fadeInUp': box3Visible,
          }"
          :style="{
            animationDelay: box3Visible ? '0.9s' : '0s',
          }"
        >
          <div class="model_item-inner">
            <div class="model_item-face model_item-front bg2">
              <img src="../assets/buju_icon2.png" alt="" />
              <span></span>
              <h1>机电配电</h1>
              <h2>配电改造、配电增容、减容，电力维护、迁改工程等</h2>
            </div>
            <div class="model_item-face model_item-back">
              <h3>机电配电</h3>
              <p>全场景机电系统解决方案，满足高可靠用电需求。</p>
              <span class="back-cta">了解方案 →</span>
            </div>
          </div>
        </div>
        <div
          class="model_item"
          :class="{
            'animate__animated animate__fadeInUp': box3Visible,
          }"
          :style="{
            animationDelay: box3Visible ? '1.2s' : '0s',
          }"
        >
          <div class="model_item-inner">
            <div class="model_item-face model_item-front bg3">
              <img src="../assets/buju_icon3.png" alt="" />
              <span></span>
              <h1>综合能源</h1>
              <h2>具备与大型开发商、商业/公共建筑电力合作资质</h2>
            </div>
            <div class="model_item-face model_item-back">
              <h3>综合能源</h3>
              <p>多能互补布局，助力园区与城市能效升级。</p>
              <span class="back-cta">探索更多 →</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box4" ref="box4Section">
      <div class="content">
        <div class="title-group" :class="{ 'animate-guanyu': box4Visible }">
          <div class="en_title">Key Capabilities</div>
          <div class="ch_title">核心能力</div>
        </div>
        <h1>通过强大研发团队、先进制造技术、定制化解决方案服务客户</h1>
        <ul
          class="zizhu"
          ref="featureSection"
          :class="{ 'is-visible': featureVisible }"
        >
          <li>
            <img src="../assets/zizhu.png" alt="" />
            <div class="zizhu_right">
              <h2>自主产线</h2>
              <h3>电芯量产线/PACK量产线</h3>
            </div>
          </li>
          <li>
            <img src="../assets/zizhu.png" alt="" />
            <div class="zizhu_right">
              <h2>敏捷定制</h2>
              <h3>方案48H/产品开发7D/高效交付</h3>
            </div>
          </li>
          <li>
            <img src="../assets/zizhu.png" alt="" />
            <div class="zizhu_right">
              <h2>强大研发团队</h2>
              <h3>
                15年沉淀的研发团队(曾为宝马、奔驰、路特斯、博世等客户提供服务)
              </h3>
            </div>
          </li>
        </ul>
        <div class="title-group" :class="{ 'animate-guanyu': box4Visible }">
          <div class="en_title">End-to-End Solution</div>
          <div class="ch_title">全面解决方案</div>
        </div>
        <div class="fangan">
          <ul
            class="bg0"
            :class="{ 'animate-guanyu': box4Visible }"
            :style="{
              animationDelay: box4Visible ? '0.68s' : '0s',
            }"
          >
            <h1>电芯</h1>
            <li>高一致性</li>
            <li>高安全</li>
            <li>大倍率快充</li>
            <li>长寿命</li>
          </ul>
          <ul
            class="bg1"
            :class="{ 'animate-guanyu': box4Visible }"
            :style="{
              animationDelay: box4Visible ? '0.98s' : '0s',
            }"
          >
            <h1>电池包</h1>
            <li>可靠高效</li>
            <li>集成液冷，精确控温</li>
            <li>高效成组，续航加倍</li>
            <li>多重安全措施</li>
          </ul>
          <ul
            class="bg2"
            :class="{ 'animate-guanyu': box4Visible }"
            :style="{
              animationDelay: box4Visible ? '1.28s' : '0s',
            }"
          >
            <h1>储能系统</h1>
            <li>户储、工商业、发电侧全品类</li>
            <li>四层安全保护及监测</li>
            <li>具备1C以上大倍率充放电</li>
            <li>削峰填谷、备电响应</li>
            <li>调峰调频多功能</li>
          </ul>
          <ul
            class="bg3"
            :class="{ 'animate-guanyu': box4Visible }"
            :style="{
              animationDelay: box4Visible ? '1.58s' : '0s',
            }"
          >
            <h1>动力系统</h1>
            <li>电动重卡、矿卡、工程机械全品类</li>
            <li>重型车辆快充</li>
            <li>恶劣工况适应</li>
            <li>CTP正像开发</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="box5" ref="box5Section">
      <div class="content">
        <div class="title-group" :class="{ 'animate-guanyu': box5Visible }">
          <div class="en_title">Company Honors</div>
          <div class="ch_title">公司荣誉</div>
        </div>
        <div class="rongyu">
          <div class="half_rongyu">
            <el-carousel
              :interval="4000"
              type="card"
              height="253px"
              indicator-position="none"
              arrow="never"
            >
              <el-carousel-item v-for="item in 3" :key="item">
                <img
                  src="../assets/zhengshu.png"
                  alt="证书"
                  style="width: 100%; height: 100%; object-fit: contain"
                />
              </el-carousel-item>
            </el-carousel>
            <img src="../assets/box5_icon1.png" alt="" />
          </div>
          <div class="half_rongyu">
            <el-carousel
              :interval="4000"
              type="card"
              height="253px"
              indicator-position="none"
              arrow="never"
            >
              <el-carousel-item v-for="item in 3" :key="item">
                <img
                  src="../assets/zhengshu.png"
                  alt="证书"
                  style="width: 100%; height: 100%; object-fit: contain"
                />
              </el-carousel-item>
            </el-carousel>
            <img src="../assets/box5_icon1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="box6" ref="box6Section">
      <div class="content">
        <div class="title-group" :class="{ 'animate-guanyu': box6Visible }">
          <div class="en_title">Client Partners</div>
          <div class="ch_title">合作客户</div>
        </div>
        <h1>抢占战略要塞，前沿成果融贯内外</h1>
        <div class="model">
          <div class="marquee-grid">
            <div
              class="marquee-track"
              v-for="row in 2"
              :key="`partner-row-${row}`"
              :class="{ reverse: row === 2 }"
            >
              <img
                v-for="logo in partnerLogos"
                :key="`partner-${row}-${logo.id}`"
                :src="logo.src"
                alt="合作客户"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box7" ref="box7Section">
      <div class="content">
        <div class="box7_top">
          <div class="box7_left">
            <div class="title-group" :class="{ 'animate-guanyu': box7Visible }">
              <div class="en_title">Corporate News</div>
              <div class="ch_title">企业新闻</div>
            </div>
          </div>
          <div class="box7_right">
            <span>查看更多</span><i class="el-icon-right"></i>
          </div>
        </div>
        <div class="box7_bottom">
          <div
            class="news"
            v-for="(newsImg, index) in newsImages"
            :key="index"
            :class="{ 'animate-guanyu': box7Visible }"
            :style="{
              animationDelay: box7Visible ? `${0.35 + index * 0.3}s` : '0s',
            }"
          >
            <img :src="newsImg" alt="" />
            <div class="news_content">
              <div class="mainContent">
                <p>
                  商用动力"芯"搭档｜瑞浦兰钧携全新商用车产品阵容亮相武汉商用车展
                </p>
                <span>11/14/2025</span>
              </div>
              <i class="el-icon-top-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    // 批量导入企业logo图片
    const logoContext = require.context("../assets/qiye", false, /\.png$/);
    const logoImages = logoContext.keys().map(logoContext);
    // 为了无缝滚动，将logo重复一次，总共24个
    const totalLogos = 24;
    // 规划数据
    const guihuaData = [
      {
        img: require("../assets/guihua0.png"),
        text: "一期占地面积150亩年产能5GWh",
      },
      {
        img: require("../assets/guihua1.png"),
        text: "二期规划面积200亩年产能15TGWh",
      },
      {
        img: require("../assets/guihua2.png"),
        text: "交通便利，距东阳高铁站10公里",
      },
    ];
    // 新闻图片
    const newsImages = [
      require("../assets/news0.png"),
      require("../assets/news1.png"),
      require("../assets/news2.png"),
    ];
    return {
      partnerLogos: Array.from({ length: totalLogos }, (_, index) => ({
        id: index,
        src: logoImages[index % logoImages.length],
      })),
      guihuaData,
      newsImages,
      featureVisible: false,
      modelVisible: false,
      modelObserver: null,
      currentModelTab: 0,
      box2RightVisible: false,
      box2Observer: null,
      guanyuVisible: false,
      guihuaVisible: false,
      box3Visible: false,
      box3Observer: null,
      box4Visible: false,
      box4Observer: null,
      box5Visible: false,
      box5Observer: null,
      box6Visible: false,
      box6Observer: null,
      box7Visible: false,
      box7Observer: null,
      hoveredAnchor: null,
      anchorPoints: [
        {
          id: "intro",
          title: "企业简介",
          desc: "了解主营业务概览",
          icon: "el-icon-office-building",
          targetRef: "box2Section",
          position: { top: "42%", left: "56%" },
          offset: 1,
        },
        {
          id: "solution",
          title: "核心能力",
          desc: "研发与解决方案",
          icon: "el-icon-guide",
          targetRef: "box4Section",
          position: { top: "68%", left: "38%" },
        },
        {
          id: "honor",
          title: "公司荣誉",
          desc: "发展历程与荣誉墙",
          icon: "el-icon-medal",
          targetRef: "box5Section",
          position: { top: "28%", left: "79%" },
        },
        {
          id: "partners",
          title: "合作客户",
          desc: "全球伙伴战略布局",
          icon: "el-icon-connection",
          targetRef: "box6Section",
          position: { top: "42%", left: "83%" },
          align: "left",
        },
        {
          id: "news",
          title: "企业新闻",
          desc: "实时洞察跃动动态",
          icon: "el-icon-news",
          targetRef: "box7Section",
          position: { top: "52%", left: "20%" },
        },
      ],
    };
  },
  mounted() {
    // 所有动画都由各自的 boxObserver 统一管理，不再单独设置
    this.setupBox2Observer();
    this.setupBox3Observer();
    this.setupBox4Observer();
    this.setupBox5Observer();
    this.setupBox6Observer();
    this.setupBox7Observer();
  },
  beforeDestroy() {
    this.teardownModelObserver();
    this.teardownBox2Observer();
    this.teardownBox3Observer();
    this.teardownBox4Observer();
    this.teardownBox5Observer();
    this.teardownBox6Observer();
    this.teardownBox7Observer();
  },
  methods: {
    setModelTab(index) {
      this.currentModelTab = index;
    },
    setupModelObserver() {
      const target = this.$refs.modelTrigger || this.$refs.modelSection;
      if (!target) {
        this.modelVisible = true;
        return;
      }
      if (
        typeof window === "undefined" ||
        !("IntersectionObserver" in window)
      ) {
        this.modelVisible = true;
        return;
      }
      this.modelObserver = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry && entry.isIntersecting) {
            this.modelVisible = true;
            this.teardownModelObserver();
          }
        },
        {
          root: null,
          threshold: 1,
          rootMargin: "0px 0px -33% 0px",
        }
      );
      this.modelObserver.observe(target);
    },
    teardownModelObserver() {
      if (this.modelObserver) {
        this.modelObserver.disconnect();
        this.modelObserver = null;
      }
    },
    cardAnimationStyle(localIndex = 0, groupOffset = 0) {
      const staggerStep = 0.45;
      const delay = Math.max(0, groupOffset + localIndex) * staggerStep;
      return {
        "--card-delay": `${delay.toFixed(2)}s`,
      };
    },
    handleGuihuaAnimationEnd(event, index) {
      // 进入动画完成后，添加浮动动画
      if (
        event.animationName === "backInRight" ||
        event.animationName.includes("backInRight")
      ) {
        const boxes = this.$refs.guihuaBoxes;
        if (boxes && boxes[index]) {
          boxes[index].classList.add("float-animation");
        }
      }
    },
    setupBox2Observer() {
      const target = this.$refs.box2Section;
      if (!target) {
        this.box2RightVisible = true;
        this.guanyuVisible = true;
        this.modelVisible = true;
        this.guihuaVisible = true;
        return;
      }
      if (
        typeof window === "undefined" ||
        !("IntersectionObserver" in window)
      ) {
        this.box2RightVisible = true;
        this.guanyuVisible = true;
        this.modelVisible = true;
        this.guihuaVisible = true;
        return;
      }
      this.box2Observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry && entry.isIntersecting) {
            // 重置所有动画：先移除类，然后重新添加以触发动画
            this.box2RightVisible = false;
            this.guanyuVisible = false;
            this.modelVisible = false;
            this.guihuaVisible = false;

            // 清除浮动动画类
            const boxes = this.$refs.guihuaBoxes;
            if (boxes) {
              boxes.forEach((box) => {
                if (box) {
                  box.classList.remove("float-animation");
                }
              });
            }

            this.$nextTick(() => {
              // 重新触发所有动画
              this.box2RightVisible = true;
              this.guanyuVisible = true;
              this.modelVisible = true;
              this.guihuaVisible = true;
            });
          } else {
            // 离开视口时重置状态，以便下次进入时重新触发
            this.box2RightVisible = false;
            this.guanyuVisible = false;
            this.modelVisible = false;
            this.guihuaVisible = false;

            // 清除浮动动画类
            const boxes = this.$refs.guihuaBoxes;
            if (boxes) {
              boxes.forEach((box) => {
                if (box) {
                  box.classList.remove("float-animation");
                }
              });
            }
          }
        },
        { root: null, threshold: 0.2 }
      );
      this.box2Observer.observe(target);
    },
    teardownBox2Observer() {
      if (this.box2Observer) {
        this.box2Observer.disconnect();
        this.box2Observer = null;
      }
    },
    setupBox3Observer() {
      const target = this.$refs.box3Section;
      if (!target) {
        this.box3Visible = true;
        return;
      }
      if (
        typeof window === "undefined" ||
        !("IntersectionObserver" in window)
      ) {
        this.box3Visible = true;
        return;
      }
      this.box3Observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry && entry.isIntersecting) {
            // 重置动画：先移除类，然后重新添加以触发动画
            this.box3Visible = false;
            this.$nextTick(() => {
              this.box3Visible = true;
            });
          } else {
            // 离开视口时重置状态，以便下次进入时重新触发
            this.box3Visible = false;
          }
        },
        { root: null, threshold: 0.2 }
      );
      this.box3Observer.observe(target);
    },
    teardownBox3Observer() {
      if (this.box3Observer) {
        this.box3Observer.disconnect();
        this.box3Observer = null;
      }
    },
    setupBox4Observer() {
      const target = this.$refs.box4Section;
      if (!target) {
        this.box4Visible = true;
        this.featureVisible = true;
        return;
      }
      if (
        typeof window === "undefined" ||
        !("IntersectionObserver" in window)
      ) {
        this.box4Visible = true;
        this.featureVisible = true;
        return;
      }
      this.box4Observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry && entry.isIntersecting) {
            // 重置动画：先移除类，然后重新添加以触发动画
            this.box4Visible = false;
            this.featureVisible = false;
            this.$nextTick(() => {
              this.box4Visible = true;
              this.featureVisible = true;
            });
          } else {
            // 离开视口时重置状态，以便下次进入时重新触发
            this.box4Visible = false;
            this.featureVisible = false;
          }
        },
        { root: null, threshold: 0.2 }
      );
      this.box4Observer.observe(target);
    },
    teardownBox4Observer() {
      if (this.box4Observer) {
        this.box4Observer.disconnect();
        this.box4Observer = null;
      }
    },
    anchorStyle(point) {
      return {
        top: point.position.top,
        left: point.position.left,
      };
    },
    handleAnchorClick(point) {
      const target = this.$refs[point.targetRef];
      if (!target) {
        return;
      }
      const headerOffset = point.offset ?? 70;
      const rect = target.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const top = scrollTop + rect.top - headerOffset;
      window.scrollTo({
        top,
        behavior: "smooth",
      });
    },
    setupBox5Observer() {
      const target = this.$refs.box5Section;
      if (!target) {
        this.box5Visible = true;
        return;
      }
      if (
        typeof window === "undefined" ||
        !("IntersectionObserver" in window)
      ) {
        this.box5Visible = true;
        return;
      }
      this.box5Observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry && entry.isIntersecting) {
            this.box5Visible = false;
            this.$nextTick(() => {
              this.box5Visible = true;
            });
          } else {
            this.box5Visible = false;
          }
        },
        { root: null, threshold: 0.2 }
      );
      this.box5Observer.observe(target);
    },
    teardownBox5Observer() {
      if (this.box5Observer) {
        this.box5Observer.disconnect();
        this.box5Observer = null;
      }
    },
    setupBox6Observer() {
      const target = this.$refs.box6Section;
      if (!target) {
        this.box6Visible = true;
        return;
      }
      if (
        typeof window === "undefined" ||
        !("IntersectionObserver" in window)
      ) {
        this.box6Visible = true;
        return;
      }
      this.box6Observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry && entry.isIntersecting) {
            this.box6Visible = false;
            this.$nextTick(() => {
              this.box6Visible = true;
            });
          } else {
            this.box6Visible = false;
          }
        },
        { root: null, threshold: 0.2 }
      );
      this.box6Observer.observe(target);
    },
    teardownBox6Observer() {
      if (this.box6Observer) {
        this.box6Observer.disconnect();
        this.box6Observer = null;
      }
    },
    setupBox7Observer() {
      const target = this.$refs.box7Section;
      if (!target) {
        this.box7Visible = true;
        return;
      }
      if (
        typeof window === "undefined" ||
        !("IntersectionObserver" in window)
      ) {
        this.box7Visible = true;
        return;
      }
      this.box7Observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry && entry.isIntersecting) {
            this.box7Visible = false;
            this.$nextTick(() => {
              this.box7Visible = true;
            });
          } else {
            this.box7Visible = false;
          }
        },
        { root: null, threshold: 0.2 }
      );
      this.box7Observer.observe(target);
    },
    teardownBox7Observer() {
      if (this.box7Observer) {
        this.box7Observer.disconnect();
        this.box7Observer = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  display: flex;
  flex-direction: column;
  & > div {
    opacity: 0;
    transform: translateY(40px);
    animation: fadeInUp 0.9s ease forwards;
  }
  & > div:nth-child(1) {
    animation-delay: 0.1s;
  }
  & > div:nth-child(2) {
    animation-delay: 0.25s;
  }
  & > div:nth-child(3) {
    animation-delay: 0.4s;
  }
  & > div:nth-child(4) {
    animation-delay: 0.55s;
  }
  & > div:nth-child(5) {
    animation-delay: 0.7s;
  }
  & > div:nth-child(6) {
    animation-delay: 0.85s;
  }
  & > div:nth-child(7) {
    animation-delay: 1s;
  }
  & > div:nth-child(8) {
    animation-delay: 1.15s;
  }
  .en_title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #999999;
  }
  .ch_title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #000000;
  }
  .title-group {
    display: flex;
    flex-direction: column;
    opacity: 0;
    transform: translateX(-55px);
    &.animate-guanyu {
      animation: guanyuSlideIn 1.05s ease forwards 0.35s;
    }
  }
  .content {
    max-width: min(1650px, 95vw);
    width: 100%;
    margin: 0 auto;
    display: flex;
  }
  .box1 {
    width: 100%;
    position: relative;
    .banner-video {
      width: 100%;
      height: auto;
      display: block;
      object-fit: cover;
    }
    .anchor-panel {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      .anchor-point {
        position: absolute;
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
        pointer-events: auto;
      }
      .anchor-point.align-left {
        flex-direction: row-reverse;
      }
      .anchor-dot {
        position: relative;
        width: 26px;
        height: 26px;
        .dot-core {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #ffffff;
          transform: translate(-50%, -50%);
          image-rendering: pixelated;
          image-rendering: -moz-crisp-edges;
          image-rendering: crisp-edges;
          // 模拟像素化边缘
          box-shadow: 0 0 0 0.5px rgba(255, 255, 255, 0.6),
            0 0 0 1px rgba(255, 255, 255, 0.4),
            0 0 0 1.5px rgba(255, 255, 255, 0.2);
          &::after {
            display: none;
          }
        }
        .dot-wave {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background: radial-gradient(
            circle,
            transparent 35%,
            rgba(255, 255, 255, 0.95) 35%,
            rgba(255, 255, 255, 0.65) 70%,
            rgba(255, 255, 255, 0.35) 100%
          );
          transform: translate(-50%, -50%);
          animation: ripple 2.8s infinite;
          filter: drop-shadow(0 0 12px rgba(255, 255, 255, 0.7));
        }
        .dot-wave.delay {
          animation-delay: 1.4s;
        }
      }
      .anchor-card {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 20px;
        border-radius: 32px;
        background: rgba(255, 255, 255, 0.95);
        color: #333;
        box-shadow: 0 12px 30px rgba(255, 255, 255, 0.4);
        opacity: 0;
        transform: translateX(-10px);
        pointer-events: none;
        transition: opacity 0.35s ease, transform 0.35s ease;
        .anchor-icon {
          font-size: 18px;
        }
        .anchor-text {
          display: flex;
          flex-direction: column;
          h4 {
            font-size: 14px;
            font-weight: 600;
          }
          p {
            font-size: 12px;
            opacity: 0.9;
          }
        }
        .anchor-arrow {
          font-size: 16px;
        }
      }
      .anchor-card.is-visible {
        opacity: 1;
        transform: translateX(0);
        pointer-events: auto;
      }
      .anchor-point.align-left .anchor-card {
        text-align: right;
        transform: translateX(10px);
      }
      .anchor-point.align-left .anchor-card .anchor-text {
        align-items: flex-end;
      }
      .anchor-point.align-left .anchor-card .anchor-arrow {
        transform: rotate(180deg);
      }
      .anchor-point.align-left .anchor-card.is-visible {
        transform: translateX(0);
      }
    }
  }
  .box2 {
    width: 100%;
    height: 990px;
    background: url(../assets/banner2.png) no-repeat center/cover;
    display: flex;
    padding: 100px 0 95px 0;
    box-sizing: border-box;
    .content {
      justify-content: space-between;
    }
    .box2_left {
      display: flex;
      flex-direction: column;
      align-items: space-between;
      .guanyu {
        display: flex;
        flex-direction: column;
        opacity: 0;
        transform: translateX(-55px);
        &.animate-guanyu {
          animation: guanyuSlideIn 1.05s ease forwards 0.35s;
        }

        p {
          max-width: 544px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          line-height: 30px;
          text-align: left;
          margin-top: 25px;
        }
      }
      .yewu {
        display: flex;
        flex-direction: column;
        margin-top: auto;
        perspective: 1200px;
        .xinghao {
          h1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 22px;
            color: #000000;
            margin: 20px 0;
          }
          .rongqi {
            display: flex;
            gap: 10px;
          }
          .xinghao_box {
            width: 139px;
            height: 111px;
            background: #ffffff;
            border-radius: 6px;
            border: 1px solid #efeded;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 15px 0;
            box-sizing: border-box;
            transition: transform 0.4s ease, box-shadow 0.4s ease;
            opacity: 0;
            transform: perspective(900px) rotateX(18deg) translateY(30px);
            transform-origin: top center;
            backface-visibility: hidden;
            img {
              width: 56px;
              height: 56px;
              margin-bottom: 5px;
            }
            span {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              text-align: center;
            }
          }
        }
        &.is-visible .xinghao_box {
          animation: cardFlipIn 1.4s cubic-bezier(0.17, 0.67, 0.35, 1.2)
            forwards;
          animation-delay: var(--card-delay, 0s);
        }
      }
    }
    .box2_right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      h1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 30px;
        text-align: left;
        margin: 13px 0 25px 0;
      }
      .guihua {
        display: flex;
        gap: 22px;
        .guihua_box {
          width: 282px;
          height: 400px;
          position: relative;
          overflow: hidden;
          border-radius: 22px;
          transition: transform 0.4s ease, box-shadow 0.4s ease;
          img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
          span {
            position: absolute;
            top: 40px;
            left: 30px;
            width: 222px;
            font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 26px;
            color: #ffffff;
            line-height: 32px;
            text-align: left;
            text-shadow: 0 6px 18px rgba(0, 0, 0, 0.45);
          }
          &:hover {
            transform: translateY(-12px);
            box-shadow: 0 25px 50px rgba(5, 41, 112, 0.35);
          }
          // 浮动动画类，在进入动画完成后添加
          &.float-animation {
            animation: subtleFloat 9s ease-in-out infinite;
          }
        }
        // 为每个卡片设置不同的浮动延迟，保持错落有致
        .guihua_box.float-animation:nth-child(1) {
          animation-delay: 0s;
        }
        .guihua_box.float-animation:nth-child(2) {
          animation-delay: 0.8s;
        }
        .guihua_box.float-animation:nth-child(3) {
          animation-delay: 1.6s;
        }
      }
    }
  }
  .box3 {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 66px;
    box-sizing: border-box;
    ul {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 150px;
      margin-bottom: 67px;
      li {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: rgba(0, 0, 0, 0.5);
        list-style: none;
        padding-bottom: 10px;
        box-sizing: border-box;
        border-bottom: 2px solid transparent;
        position: relative;
        cursor: pointer;
      }
      li.active {
        font-weight: 500;
        color: #000000;
        padding-bottom: 10px;
        box-sizing: border-box;
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, #0643bf 0%, #1d8bfd 100%);
        }
      }
    }
    .model {
      width: 100%;
      display: flex;
      perspective: 1400px;
      .model_item {
        width: 25%;
        height: 806px;
        display: flex;
        align-items: center;
        justify-content: center;
        perspective: inherit;
      }
      .model_item-inner {
        width: 100%;
        height: 100%;
        position: relative;
        transform-style: preserve-3d;
        transition: transform 0.85s cubic-bezier(0.19, 1, 0.22, 1),
          box-shadow 0.85s ease;
        box-shadow: 0 25px 55px rgba(0, 0, 0, 0.35);
      }
      .model_item-face {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 30px;
        text-align: center;
        color: #ffffff;
        backface-visibility: hidden;
      }
      .model_item-front {
        background: inherit;
      }
      .model_item-front::before {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        transition: background 0.5s ease;
      }
      .model_item-front > * {
        position: relative;
        z-index: 2;
      }
      .model_item-front img {
        width: 76px;
        height: 76px;
        transition: transform 0.5s ease;
      }
      .model_item-front span {
        width: 28px;
        height: 2px;
        background: #ffffff;
        margin: 25px 0 20px 0;
        transition: width 0.4s ease;
      }
      .model_item-front h1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        margin-bottom: 13px;
      }
      .model_item-front h2 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
      }
      .model_item-back {
        background: linear-gradient(135deg, #0c44ff, #1d8bfd);
        transform: rotateY(180deg);
        gap: 16px;
        padding: 0 40px;
      }
      .model_item-back h3 {
        font-size: 28px;
        font-weight: 600;
      }
      .model_item-back p {
        font-size: 16px;
        line-height: 26px;
        opacity: 0.9;
      }
      .model_item-back .back-cta {
        font-size: 14px;
        letter-spacing: 0.5px;
        padding: 8px 22px;
        border: 1px solid rgba(255, 255, 255, 0.6);
        border-radius: 999px;
        transition: background 0.3s ease, color 0.3s ease;
        cursor: pointer;
      }
      .model_item-back .back-cta:hover {
        background: #ffffff;
        color: #0c44ff;
      }
      .model_item-front.bg0 {
        background: url(../assets/buju0.png) no-repeat center/cover;
      }
      .model_item-front.bg1 {
        background: url(../assets/buju1.png) no-repeat center/cover;
      }
      .model_item-front.bg2 {
        background: url(../assets/buju2.png) no-repeat center/cover;
      }
      .model_item-front.bg3 {
        background: url(../assets/buju3.png) no-repeat center/cover;
      }
      .model_item:hover .model_item-inner {
        transform: rotateY(180deg);
        box-shadow: 0 35px 85px rgba(0, 0, 0, 0.45);
      }
      .model_item:hover .model_item-front::before {
        background: rgba(6, 67, 191, 0.55);
      }
      .model_item:hover .model_item-front img {
        transform: scale(1.08);
      }
      .model_item:hover .model_item-front span {
        width: 46px;
      }
    }
  }
  .box4 {
    padding: 100px 0;
    box-sizing: border-box;
    .content {
      flex-direction: column;
      h1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 30px;
        margin: 15px 0 30px 0;
      }
      .zizhu {
        display: flex;
        gap: 40px;
        margin-bottom: 40px;
        li {
          display: flex;
          padding: 18px 22px;
          border-radius: 18px;
          background: rgba(6, 67, 191, 0.05);
          transition: transform 0.4s ease, box-shadow 0.4s ease;
          box-shadow: 0 0 0 rgba(6, 67, 191, 0);
          opacity: 0;
          transform: translateY(35px);
          animation-fill-mode: forwards;
          img {
            width: 42px;
            height: 42px;
          }
          .zizhu_right {
            display: flex;
            flex-direction: column;
            margin-left: 8px;
            h2 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 16px;
              color: #121212;
            }
            h3 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: rgba(18, 18, 18, 0.5);
            }
          }
          &:hover {
            transform: translateY(-6px);
            box-shadow: 0 18px 30px rgba(6, 67, 191, 0.15);
          }
        }
        &.is-visible li {
          animation: featureFadeIn 0.95s ease forwards;
        }
        &.is-visible li:nth-child(2) {
          animation-delay: 0.18s;
        }
        &.is-visible li:nth-child(3) {
          animation-delay: 0.36s;
        }
      }
      .fangan {
        display: flex;
        gap: 20px;
        margin-top: 25px;
        .bg0 {
          background: url(../assets/fangan0.png) no-repeat center/cover;
        }
        .bg1 {
          background: url(../assets/fangan1.png) no-repeat center/cover;
        }
        .bg2 {
          background: url(../assets/fangan2.png) no-repeat center/cover;
        }
        .bg3 {
          background: url(../assets/fangan3.png) no-repeat center/cover;
        }
        ul {
          width: 397px;
          height: 301px;
          padding: 24px;
          box-sizing: border-box;
          position: relative;
          overflow: hidden;
          // border-radius: 18px;
          transition: transform 0.45s ease, box-shadow 0.45s ease;
          opacity: 0;
          transform: translateX(-55px);
          &.animate-guanyu {
            animation: guanyuSlideIn 1.05s ease forwards;
          }
          &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
            z-index: 1;
          }
          h1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #ffffff;
            margin-bottom: 20px;
            position: relative;
            z-index: 2;
          }
          li {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            line-height: 26px;
            margin-left: 24px;
            position: relative;
            z-index: 2;
          }
          &:hover {
            transform: translateY(-12px) scale(1.01);
            box-shadow: 0 25px 45px rgba(0, 0, 0, 0.35);
          }
        }
      }
    }
  }
  .box5 {
    width: 100%;
    height: 665px;
    background: url(../assets/box5_bg.png) no-repeat center/cover;
    padding: 100px 0;
    box-sizing: border-box;
    .content {
      flex-direction: column;
    }
    .rongyu {
      width: 100%;
      height: 330px;
      display: flex;
      justify-content: space-between;
      margin-top: 70px;
      .half_rongyu {
        width: 49%;
        height: 100%;
        position: relative;
        padding: 20px 0;
        // border-radius: 30px;
        background: rgba(255, 255, 255, 0.05);
        // backdrop-filter: blur(4px);
        // transition: transform 0.5s ease, box-shadow 0.5s ease;
        .el-carousel {
          margin: 0 70px;
          z-index: 2;
          // transition: transform 0.5s ease;
          :deep(.el-carousel__mask) {
            background-color: transparent !important;
            opacity: 0 !important;
          }
        }
        img {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 123px;
          z-index: 1;
        }
        // &:hover {
        //   transform: translateY(-15px);
        //   box-shadow: 0 35px 60px rgba(0, 0, 0, 0.35);
        //   .el-carousel {
        //     transform: translateY(-6px);
        //   }
        // }
      }
    }
  }
  .box6 {
    width: 100%;
    height: 535px;
    background: url(../assets/box6_bg.png) no-repeat center/cover;
    padding: 100px 0;
    box-sizing: border-box;
    .en_title,
    .ch_title {
      color: #fff;
    }
    .content {
      flex-direction: column;
    }
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 30px;
      margin: 15px 0 34px 0;
    }
    .model {
      width: 100%;
      overflow: hidden;
      position: relative;
      mask-image: linear-gradient(
        to right,
        transparent,
        rgba(0, 0, 0, 1) 10%,
        rgba(0, 0, 0, 1) 90%,
        transparent
      );
      .marquee-grid {
        display: flex;
        flex-direction: column;
        gap: 28px;
      }
      .marquee-track {
        display: flex;
        gap: 35px;
        animation: partnerMarqueeForward 46s linear infinite;
        width: fit-content;
        &:hover {
          animation-play-state: paused;
        }
      }
      .marquee-track.reverse {
        animation-name: partnerMarqueeReverse;
        animation-delay: -23s;
      }
      img {
        width: 180px;
        height: 90px;
        flex-shrink: 0;
        background: rgba(255, 255, 255, 0.08);
        filter: grayscale(25%);
        transition: transform 0.35s ease, filter 0.35s ease,
          box-shadow 0.35s ease;
        box-shadow: 0 0 0 rgba(0, 0, 0, 0);
      }
    }
  }
  .box7 {
    padding: 100px 0;
    box-sizing: border-box;
    .content {
      flex-direction: column;
    }
    .box7_top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .box7_right {
        width: 136px;
        height: 36px;
        background: #ffffff;
        border-radius: 18px 0px 18px 18px;
        border: 1px solid #8c8c8c;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #000000;
          text-align: left;
          margin-right: 5px;
        }
      }
    }
    .box7_bottom {
      display: flex;
      margin-top: 35px;
      gap: 28px;
      width: 100%;
      .news {
        width: 32%;
        border-radius: 28px;
        overflow: hidden;
        box-shadow: 0 0 0 rgba(0, 0, 0, 0);
        transition: transform 0.45s ease, box-shadow 0.45s ease;
        opacity: 0;
        transform: translateX(-55px);
        cursor: pointer;
        &.animate-guanyu {
          animation: guanyuSlideIn 1.05s ease forwards;
        }
        img {
          width: 100%;
          height: 229px;
        }
        .news_content {
          height: 114px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #f5f5f5;
          padding: 15px 30px;
          box-sizing: border-box;
          .mainContent {
            display: flex;
            flex-direction: column;
            p {
              max-width: 409px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 20px;
              color: #333333;
              text-align: left;
              margin-bottom: 5px;
            }
            span {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
              text-align: left;
            }
          }
          :deep(.el-icon-top-right) {
            font-size: 28px;
            width: 28px; /* 控制布局 */
            height: 28px; /* 控制布局 */
            color: #666;
            transition: transform 0.4s ease;
          }
        }
        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 30px 55px rgba(0, 0, 0, 0.25);
          .news_content {
            background: #ffffff;
          }
          :deep(.el-icon-top-right) {
            transform: translateX(6px) translateY(-6px);
            color: #0643bf;
          }
        }
      }
    }
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes subtleFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
@keyframes partnerMarqueeForward {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
@keyframes partnerMarqueeReverse {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes featureFadeIn {
  0% {
    opacity: 0;
    transform: translateY(35px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes cardFlipIn {
  0% {
    opacity: 0;
    transform: perspective(900px) rotateX(18deg) translateY(30px);
  }
  60% {
    opacity: 1;
    transform: perspective(900px) rotateX(-6deg) translateY(-4px);
  }
  100% {
    opacity: 1;
    transform: perspective(900px) rotateX(0deg) translateY(0);
  }
}

@keyframes ripple {
  0% {
    opacity: 0.9;
    transform: translate(-50%, -50%) scale(0.4);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(2.2);
  }
}

@keyframes guanyuSlideIn {
  0% {
    opacity: 0;
    transform: translateX(-55px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
